const validateEmail = (email: string) =>
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum|fund|xyz|top|online|tech|dev|club|app|pro|site|shop|win|store|space|download|live|cloud|work|one|life|link|ltd|design|network|email|science|blog|zone|news|host|website|trade)\b/i.test(
    email,
  )

const formValidations = { validateEmail }

export default formValidations
